import { Injectable } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';

@Injectable()
export class ModalService {
    constructor(private dialogService: DialogService) {}

    open(component, data) {
        return this.openModal(component, data, true);
    }

    openModal(component, data, closeByClickingOutside) {
        return this.dialogService
            .addDialog(component, data, {
                backdropColor: 'rgba(0, 0, 0, 0.5)',
                closeByClickingOutside: false
            })
            .map(resultData => {
                document
                    .getElementsByTagName('body')[0]
                    .classList.remove('modal-open');
                return resultData;
            });
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/modalService/modal.service.ts